import { useCallback } from "react";
import { toast } from "react-toastify";

export const HISTORY_STORAGE_KEY = "rebbud_project_history";

export const useProjectHistory = ({ dispatch, setIsHistoryPanelOpen, t }) => {
  const handleLoadFromHistory = useCallback(
    (historyId) => {
      const history = JSON.parse(
        localStorage.getItem(HISTORY_STORAGE_KEY) || "[]",
      );
      const itemToLoad = history.find((item) => item.id === historyId);
      if (itemToLoad) {
        const sanitizedData = {
          projectObjects: itemToLoad.projectData.projectObjects || {},
          floors: itemToLoad.projectData.floors || [],
          currentFloorId: itemToLoad.projectData.currentFloorId,
          selectedObjectId: itemToLoad.projectData.selectedObjectId || null,
          activeMode: itemToLoad.projectData.activeMode || "modular",
          clickedJointSegmentIndex:
            itemToLoad.projectData.clickedJointSegmentIndex || null,
          framelessElementsUnlocked:
            itemToLoad.projectData.framelessElementsUnlocked || false,
          notification: null,
        };

        dispatch({ type: "SET_STATE", payload: sanitizedData });
        toast.success(t("toasts.projectLoadedFromHistory"));
        if (setIsHistoryPanelOpen) {
          setIsHistoryPanelOpen(false);
        }
      } else {
        toast.error(t("toasts.historyItemNotFound"));
      }
    },
    [dispatch, setIsHistoryPanelOpen, t],
  );

  const handleDeleteFromHistory = useCallback(
    (historyId) => {
      const history = JSON.parse(
        localStorage.getItem(HISTORY_STORAGE_KEY) || "[]",
      );
      const updatedHistory = history.filter((item) => item.id !== historyId);
      localStorage.setItem(HISTORY_STORAGE_KEY, JSON.stringify(updatedHistory));
      toast.success(t("toasts.historyItemDeleted"));
    },
    [t],
  );

  return {
    handleLoadFromHistory,
    handleDeleteFromHistory,
  };
};
